<script setup>
import { computed, onMounted, watch } from "vue"

const props = defineProps({
  isShowing: { type: Boolean },
  alertMessage: { type: String },
  type: { type: String, default: "warning" },
})

const variantClasses = {
  info: "alert alert-info",
  error: "alert alert-error",
  warning: "alert alert-warning",
  success: "alert alert-success",
  default: "alert",
}

const variantClass = computed(() => {
  return variantClasses[props.type] ?? variantClasses.default
})

const icon = computed(() => {
  switch (props.type) {
    case "info":
      return "bi-info-circle"
    case "error":
    case "warning":
      return "bi-exclamation-circle"
    case "success":
      return "bi-check-circle"
    default:
      return "bi-info-circle"
  }
})
</script>

<template>
  <div v-if="isShowing">
    <div role="alert" :class="variantClass">
      <v-icon :name="icon" class="inline-flex" scale="1" />
      <span>{{ alertMessage }}</span>
    </div>
  </div>
</template>

<style scoped>
.alert {
  @apply rounded-md shadow-md text-sm;
  padding: 0.75rem;
}
</style>
